/** ST環境・開発環境用（本番と共用かどうか作成時点では未定） */
const CognitoRegion = 'ap-northeast-1';
const CognitoUserPool = 'ap-northeast-1_n9ZprTbmj';
const CognitoUserPoolClient = '1oa0sg5tk9860btnk3g355ajd2';
const CognitoDomainPrefix = 'theory-auth';

const origin = window.location.origin;

const amplifyConfig = {
  Auth: {
    region: CognitoRegion,
    userPoolId: CognitoUserPool,
    userPoolWebClientId : CognitoUserPoolClient,
    oauth: {
      domain: `${CognitoDomainPrefix}.auth.${CognitoRegion}.amazoncognito.com`,
      scope: ['openid', 'email', 'phone', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: `${origin}/`,
      redirectSignOut: `${origin}/`,
      responseType: 'code'
    }
  }
};

export { amplifyConfig };
